import { render } from "./PrimaryBlock.vue?vue&type=template&id=64aa169f"
const script = {}

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__